import { render, staticRenderFns } from "./LectuerSelectPage.vue?vue&type=template&id=6121123d&scoped=true&"
import script from "./LectuerSelectPage.vue?vue&type=script&lang=js&"
export * from "./LectuerSelectPage.vue?vue&type=script&lang=js&"
import style0 from "./LectuerSelectPage.vue?vue&type=style&index=0&id=6121123d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6121123d",
  null
  
)

export default component.exports